import script from "./TestimonyView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonyView.vue?vue&type=script&setup=true&lang=js"

import "./TestimonyView.vue?vue&type=style&index=0&id=1c4ab48e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4ab48e"]])

export default __exports__